import { createFileRoute } from '@tanstack/react-router'
import { ChangePassword } from '@/pages/account/components/ChangePassword'

export const Route = createFileRoute('/account-change-password')({
  component: ChangePassword,
})
